export default class FollowStatus {
  constructor() {
    this.selector = 'a.button-follow.button-follow-hide[data-component*="ButtonFollow"]';
    this.userIds = this.getButtonFollowUserIds();
    if (this.userIds !== "") {
      this.getFollowStatus();
    }
  }

  getButtonFollowUserIds() {
    return $(this.selector).map(function() {
      return $(this).data('user-id');
    }).get().join(',');
  }

  getFollowStatus() {
    $.ajax({
      url: "/follow_statuses.json?user_ids=" + this.userIds,
      method: "GET"
    })
    .done(this.setFollowStatus.bind(this));
  }

  setFollowStatus(data) {
    data.forEach((status) => {
      var selector = this.selector + '[data-user-id="' + status.user_id + '"]';
      var button = $(selector);
      if(status.follow){
        button.prop("href", button.data("unfollow-path"));
        button.addClass("button-follow--following");
      } else {
        button.prop("href", button.data("follow-path"));
      }
      button.removeClass("button-follow-hide");
    });
  }
}
